import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { DatePipe } from '@angular/common';

import { FormControl, FormGroup } from '@angular/forms';

import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';

import { AufgabeDto } from '@app/dto/aufgabe.dto';
import { AufgabeEintragDto } from '@app/dto/aufgabe.eintrag.dto';
import { AufgabenService } from '@app/services/aufgaben.service';
import { VorschlagDuplikatDto } from "@app/dto/vorschlagduplikat.dto";
import { VorschlagEswDto } from "@app/dto/vorschlagEsw.dto";

declare var window: any;

@Component({
  selector: 'app-aufgaben',
  templateUrl: './aufgaben.component.html',
  styleUrls: ['./aufgaben.component.scss']
})
export class AufgabenComponent implements OnInit {

  title: string = '';
  pageSize: number = 1000;

  resultListLength: number = 0;

  aufgabenList: AufgabeDto[] = [];
  resultDataSource: any = [];

  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild('paginator') paginator!: MatPaginator | null;

  initColumns = [
    {
      name: 'firmenname',
      label: 'Name',
    },
    {
      name: 'aufgabeText',
      label: 'aufgabe',
    },
    {
      name: 'strasseUndHausnummer',
      label: 'Straße',
    },
    {
      name: 'plz',
      label: 'PLZ',
    },
    {
      name: 'ort',
      label: 'Ort',
    },
    {
      name: 'nlCode',
      label: 'NL',
    },
    {
      name: 'pcAdressnummer',
      label: 'PcAdresse',
    },
    {
      name: 'salesforceId',
      label: 'Account-ID',
    }
  ]

  displayedColumnsInit = this.initColumns.map(col => col.name);
  displayedColumns = ['realDate', ...this.displayedColumnsInit];
  displayedColumnsWithActions = [...this.displayedColumns, 'actions'];

  priorityOptions = [
    {
      name: '',
      value: null
    },
    {
      name: '1 L-Kunden',
      value: 1
    },
    {
      name: '2 K-Kunden',
      value: 2
    },
    {
      name: '3 N-Kunden',
      value: 3
    },
  ];
  dateOptions: string[] = ['vor', 'nach'];
  startDate = this.datePipe.transform(new Date(), 'dd.MM.yyyy');

  public filterForm: FormGroup = new FormGroup({
    priority:     new FormControl(null),
    dateOption:   new FormControl(this.dateOptions[0]),
    date:         new FormControl(null),
    nlCode:       new FormControl(''),
    id:           new FormControl(''),
    firmenname:   new FormControl(''),
    salesforceId: new FormControl(''),
  });

  filterString: string;

  constructor(
    private readonly aufgabenService: AufgabenService,
    private router: Router,
    private route: ActivatedRoute,
    public datePipe: DatePipe
  ) {

    this.filterString = localStorage.getItem('aufgabenFilterString') ?? '';

    const filtersLocal = localStorage.getItem('aufgabenFilters') ?? '';
    if (filtersLocal) {
      const filtersLocalObj = JSON.parse(filtersLocal);
      if (filtersLocalObj) {
        let filters = {
          priority:     filtersLocalObj.priority ?? '',
          dateOption:   filtersLocalObj.dateOption ?? '',
          date:         filtersLocalObj.date ?? '',
          nlCode:       filtersLocalObj.nlCode ?? '',
          id:           filtersLocalObj.id ?? '',
          firmenname:   filtersLocalObj.firmenname ?? '',
          salesforceId: filtersLocalObj.salesforceId ?? '',
        };

        this.filterForm.setValue(filters);
      }
    }

    this.search();
  }

  ngOnInit(): void {
    this.search();
  }

  search() {
    this.aufgabenService.getAufgabenList(this.filterString, this.pageSize)
      .subscribe(result => {

        if (result) {
          this.resultListLength = result.anzahlBasierendAufFilter;
          this.title  = "Es gibt ";
          this.title += this.resultListLength > 0 ? this.resultListLength : 'keine';
          this.title += " Zuordnungen, die geprüft werden müssen.";
          this.aufgabenList = JSON.parse(result.aufgabenAsJsonString);

          let aufgabenTableList: AufgabeEintragDto[] = [];
          this.aufgabenList.forEach(aufgabe => {

            // Vorschläge mit MatchingCode X rausfiltern
            let filteredVorschlaege:VorschlagDuplikatDto[] = [];
            if (aufgabe.azureSearchOriginal) {
              for (const vorschlag of aufgabe.azureSearchOriginal) {
                if (vorschlag.matchingCode !== 'X' && vorschlag.matchingCode !== 'BA' && vorschlag.matchingCode !== 'BB') {
                  filteredVorschlaege.push(vorschlag);
                }
              }
              aufgabe.azureSearchOriginal = filteredVorschlaege;
            }

            if (aufgabe.azureSearchESW) {
              filteredVorschlaege = [];
              for (const vorschlag of aufgabe.azureSearchESW) {
                if (vorschlag.matchingCode !== 'X' && vorschlag.matchingCode !== 'BA' && vorschlag.matchingCode !== 'BB') {
                  filteredVorschlaege.push(vorschlag);
                }
              }
              aufgabe.azureSearchESW = filteredVorschlaege;
            }

            let filteredESWVorschlaege:VorschlagEswDto[] = [];
            let usedCrefoNums:Array<number> = [];
            let usedZips:Array<string>      = [];
            let usedCities:Array<string>    = [];
            if (aufgabe.ESW) {
              filteredESWVorschlaege = [];
              for (const vorschlag of aufgabe.ESW) {
                if ( ! usedCrefoNums.includes(Number(vorschlag.crefonummer)) &&  ! usedZips.includes(vorschlag.plz) && ! usedCities.includes(vorschlag.ort)) {
                  filteredESWVorschlaege.push(vorschlag);
                  if (vorschlag.crefonummer) {
                    usedCrefoNums.push(Number(vorschlag.crefonummer));
                  }
                  usedZips.push(vorschlag.plz);
                  usedCities.push(vorschlag.ort);
                }
              }
              aufgabe.ESW = filteredESWVorschlaege;
            }

            if ( ! aufgabe.azureSearchOriginal) {
              aufgabe.azureSearchOriginal = [];
            }
            if ( ! aufgabe.azureSearchESW) {
              aufgabe.azureSearchESW = [];
            }
            if ( ! aufgabe.ESW) {
              aufgabe.ESW = [];
            }

            let aufgabeText: string = '';
            if (aufgabe.azureSearchESW.length > 0 || aufgabe.azureSearchOriginal.length > 0 || aufgabe.ESW.length > 0) {
              aufgabeText = 'Neuen Standort auf Übereinstimmung mit '

              if (aufgabe.azureSearchESW.length > 0 || aufgabe.azureSearchOriginal.length > 0) {
                aufgabeText += 'internen Vorschlägen ';
                if (aufgabe.ESW.length > 0) {
                  aufgabeText += 'und ';
                }
              }
              if (aufgabe.ESW.length > 0) {
                aufgabeText += 'ESW-Vorschlägen ';
              }
              aufgabeText += 'prüfen'

            } else {
              aufgabeText = 'Neuen Standort erzeugen';
            }

            aufgabenTableList.push({
              id:                   aufgabe.id,
              datum:                aufgabe._ts ? this.datePipe.transform(aufgabe._ts * 1000, 'dd.MM.yyyy') : null,
              realDate:             new Date(aufgabe._ts * 1000),
              pcAdressnummer:       aufgabe.original.pcAdressnummer,
              salesforceId:         aufgabe.original.salesforceId ? aufgabe.original.salesforceId : undefined,
              firmenname:           aufgabe.original.name,
              strasseUndHausnummer: aufgabe.original.strasseUndHausnummer,
              plz:                  aufgabe.original.plz,
              ort:                  aufgabe.original.ort,
              nlCode:               aufgabe.original.nlCode,
              aufgabenpakete:       aufgabe.aufgabenpakete,
              adaIstSicher:         aufgabe.adaIstSicher,
              vertrauensIndikator:  aufgabe.vertrauensIndikator,
              aufgabenTyp:          aufgabe.aufgabenTyp,
              erledigtVon:          aufgabe.erledigtVon,
              erledigtAm:           aufgabe.erledigtAm,
              aufgabeText:          aufgabeText,
              azureSearchOriginal:  aufgabe.azureSearchOriginal,
              azureSearchESW:       aufgabe.azureSearchESW,
              original:             aufgabe.original,
              ESW:                  aufgabe.ESW
            })
          });

          this.resultDataSource           = new MatTableDataSource(aufgabenTableList);
          this.resultDataSource.paginator = this.paginator;
          this.resultDataSource.sort      = this.sort;
        }
      });
  }

  sortData(data: any) {
    data.sort = this.sort;
  }

  goToAufgabe(aufgabeEintrag: AufgabeEintragDto) {
    this.aufgabenService.currentAufgabe = aufgabeEintrag;
    return this.router.navigate([`/aufgabe/${aufgabeEintrag.id}`]);
  }

  filter() {
    //build filterString
    this.filterString = '';
    if (this.filterForm.controls['priority']?.value) {
      this.filterString += ` and original.prioritaet is not null and original.prioritaet eq ${this.filterForm.controls['priority']?.value}`;
    }
    if (this.filterForm.controls['id']?.value) {
      this.filterString += ` and id eq ${this.filterForm.controls['id']?.value} or original.id eq ${this.filterForm.controls['id']?.value} `;
    }
    if (this.filterForm.controls['nlCode']?.value) {
      this.filterString += ` and original.nlCode eq ${this.filterForm.controls['nlCode']?.value}`;
    }
    if (this.filterForm.controls['firmenname']?.value) {
      this.filterString += ` and original.name like ${this.filterForm.controls['firmenname']?.value}`;
    }
    if (this.filterForm.controls['salesforceId']?.value) {
      this.filterString += ` and original.salesforceId eq ${this.filterForm.controls['salesforceId']?.value}`;
    }
    if (this.filterForm.controls['date']?.value) {
      let timestamp = (new Date(this.filterForm.controls['date']?.value)).getTime() / 1000;
      this.filterString += ` and _ts ${this.filterForm.controls['dateOption']?.value == 'vor' ? 'lt' : 'gt'} ${timestamp}`;
    }

    localStorage.setItem('aufgabenFilterString', this.filterString);
    const filters = {
      'priority':     this.filterForm.controls['priority']?.value,
      'id':           this.filterForm.controls['id']?.value,
      'nlCode':       this.filterForm.controls['nlCode']?.value,
      'firmenname':   this.filterForm.controls['firmenname']?.value,
      'salesforceId': this.filterForm.controls['salesforceId']?.value,
      'date':         this.filterForm.controls['date']?.value,
      'dateOption':   this.filterForm.controls['dateOption']?.value
    }
    localStorage.setItem('aufgabenFilters', JSON.stringify(filters));

    this.search();
  }

  removeFilters() {
    localStorage.removeItem('aufgabenFilterString');
    localStorage.removeItem('aufgabenFilters');
    window.location.reload();
  }
}
